export default {
  getAllPokemons: "https://pokeapi.co/api/v2/pokemon",
  getPokemon: "https://pokeapi.co/api/v2/pokemon/{pokemonName}",
  getPokemonImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/{number}.png"
};
